import { useGetAllActiveReviews } from '../../controllers/SurveyController';
import { TransferFunds } from '../../pages';
import { walletStore } from '../../stores';
import React, { useState } from 'react';
import constant from '../../utils/constant';

const TransferContainer = ({
	closeWalletModal,
	transferSwitchState,
	sharedState,
	pinContent,
	setPinContent,
	setShowSurvey,
	needFeedback,
}) => {
	const [bankListContent, setBankListContent] = useState(false);
	const [beneficiaryContent, setBeneficiaryContent] = useState(false);
	const [stage2, setStage2] = useState(false);

	const closeModal = () => {
		walletStore.setSelectedSubWallet({});
		closeWalletModal();
	};

	const goBack = () => {
		if (bankListContent) {
			setBankListContent(false);
		} else if (beneficiaryContent) {
			setBeneficiaryContent(false);
		} else if (pinContent) {
			setPinContent(false);
		} else if (stage2) {
			setStage2(false);
		} else {
			closeModal();
		}
	};

	return (
		<TransferFunds
			key="transferModal"
			closeTransferModal={closeModal}
			transferSwitchState={transferSwitchState}
			sharedState={sharedState}
			bankListContent={bankListContent}
			setBankListContent={setBankListContent}
			goBack={goBack}
			beneficiaryContent={beneficiaryContent}
			setBeneficiaryContent={setBeneficiaryContent}
			stage2={stage2}
			setStage2={setStage2}
			setShowSurvey={setShowSurvey}
			needFeedback={needFeedback}
		/>
	);
};

export default TransferContainer;
